/* eslint-disable @typescript-eslint/dot-notation */
import { Component, ViewEncapsulation } from '@angular/core';
import { ICellEditorParams } from 'ag-grid-community';
import { FormControl } from '@angular/forms';
import { ICellEditorAngularComp } from 'ag-grid-angular';

/**
 * Editor Custom AgGrid for Alphanumeric Input.
 * Params:
 * - notAdmissibleChars: (Optional) it allows to specify as array of char any not admissible chars.
 * - editInline (Default true) it allows to specify the preference between online or popup editor version.
 * - required: (Optional) It allows to specify required validator.
 *  NOTE: when in the AgGrid is enabled the fullRow editing this input param is ignored and the editor will be inline
 */
@Component({
    selector: 'se-alphanumeric-cell-editor',
    templateUrl: './alphanumeric-cell-editor.component.html',
    styleUrls: ['./alphanumeric-cell-editor.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AlphanumericCellEditorComponent implements ICellEditorAngularComp {

    public editInline: boolean;
    public notAdmissibleChars: Array<string>;
    public required: boolean;

    value: string;
    params: ICellEditorParams;
    cellStartEdited: boolean;
    cellWidth: string;
    formControl: FormControl;
    inlineEditor: boolean;

    agInit(params: ICellEditorParams): void {
        this.params = params;
        this.value = params.value;

        this.inlineEditor = (this.params.api.getEditingCells().length) > 1;

        this.cellWidth = params.column.getActualWidth() + 'px';

        // Recupero parametri input
        this.configCellEditor();

        this.cellStartEdited = this.params.cellStartedEdit;
    }

    getValue(): any {
        if (this.formControl && !this.formControl.invalid) {
             //Alla chiusura dell'editor se il campo è valido aggiorniamo il valore altrimenti no
            return this.formControl.value;
         }
        return null;
    }

    isCancelBeforeStart(): boolean {
        return false;
    }

    isPopup(): boolean {
        return !this.editInline;
    }

    _onFormReady(editorFromControl: FormControl) {
        this.formControl = editorFromControl;
    }

    private configCellEditor() {
        this.editInline = this.params['inlineEditor'];
        this.editInline = (this.editInline !== null && this.editInline !== undefined) ? this.editInline : true;
        this.notAdmissibleChars = this.params['notAdmissibleChars'];
        this.inlineEditor = (this.params.api.getEditingCells().length) === 1 ? this.editInline : true;
        this.required = this.params['required'];
    }
}
